import React from 'react';

import {
  Home as HomeIcon,
  ManageAccounts as ManageAccountsIcon,
  PeopleAlt as PeopleAltIcon,
  Work as WorkIcon,
  Workspaces as WorkspacesIcon,
  Wysiwyg as WysiwygIcon,
} from '@mui/icons-material';

import { appRoutes } from '@clearverify/constants';

import { BaseLayoutLeftMenu, LeftMenuLogo, ResourcesListItem } from 'src/components/common';
import { useGlobalState } from 'src/hooks/shared';
import { useCurrentUser } from 'src/hooks/user';
import { MenuItem } from 'src/types/menu';

export const LayoutLeftMenu: React.FC = () => {
  const { leftMenuDrawerState } = useGlobalState();

  const { isPartnershipCompanyUser } = useCurrentUser();

  const menuItems = React.useMemo((): MenuItem[] => {
    return [
      {
        link: appRoutes.inbox.index,
        title: 'Home',
        icon: HomeIcon,
        hide: isPartnershipCompanyUser,
      },
      {
        link: appRoutes.peos.index,
        title: 'PEOs',
        icon: WorkspacesIcon,
      },
      {
        link: appRoutes.employers.index,
        title: 'Employers',
        icon: WorkIcon,
      },
      {
        link: appRoutes.employees.index,
        title: 'Employees',
        icon: PeopleAltIcon,
        hide: isPartnershipCompanyUser,
      },
      {
        link: appRoutes.peoPayrollProviderStaff.index,
        title: 'Staff',
        icon: ManageAccountsIcon,
      },
      {
        link: appRoutes.reports.index,
        title: 'Dashboard & Reports',
        icon: WysiwygIcon,
        hide: isPartnershipCompanyUser,
      },
    ];
  }, [isPartnershipCompanyUser]);

  const rootRoute = isPartnershipCompanyUser ? appRoutes.employers.index : appRoutes.inbox.index;

  return (
    <BaseLayoutLeftMenu
      leftMenuDrawerState={leftMenuDrawerState}
      menuItemsList={menuItems}
      footer={<ResourcesListItem />}
      rootRoute={rootRoute}
      logoutRoute={appRoutes.auth.logout}
      leftMenuLogo={<LeftMenuLogo showIcon={!leftMenuDrawerState.isOpened} />}
    />
  );
};
